// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-border-selection .el-input__inner {\n  border: 0 !important;\n  margin-top: 1px;\n}", ""]);
// Exports
module.exports = exports;
